import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe from 'photoswipe'

const videoElement = 'ps-video'

export function createPsVideo(): PhotoSwipeLightbox | null {
  if (typeof document === 'undefined') return null

  const lightbox = new PhotoSwipeLightbox({
    gallery: `.${videoElement}`,
    children: 'a',
    pswpModule: () => Promise.resolve(PhotoSwipe),
  })

  lightbox.addFilter('domItemData', (itemData, element, linkEl) => {
    const href = linkEl.getAttribute('href') || ''

    if (href.endsWith('.mp4')) {
      itemData.type = 'html'
      itemData.html = `
        <div class="pswp-video-wrap" style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
          <video
            class="pswp-video-tag"
            controls
            preload="auto"
            style="max-width:100%; max-height:85vh;"
          >
            <source src="${href}" type="video/mp4">
            Ваш браузер не поддерживает видео.
          </video>
        </div>
      `
    }

    return itemData
  })

  lightbox.on('contentAppend', (e) => {
    const content = e.content
    if (!content) return

    const videoTag = content.element?.querySelector('video') as HTMLVideoElement | null
    if (!videoTag) return

    videoTag.playsInline = true
    videoTag.load()

    const tryPlay = () => {
      const p = videoTag.play()
      if (p && typeof p.catch === 'function') {
        p.catch((err) => console.error('Автозапуск не удался:', err))
      }
    }

    if (videoTag.readyState >= 2) {
      tryPlay()
    } else {
      videoTag.addEventListener('canplay', tryPlay, { once: true })
    }
  })

  lightbox.init()
  return lightbox
}
